import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/utils/axios';
import baseAxios from 'src/utils/baseAxios'
import moment from 'moment';

export const GetSurveyModuleData = createAsyncThunk(`/Survey/GetSurveyableWorkOrder`,
    async ({ serviceShopId, statusId, startDate, endDate }) => {
        const params = new URLSearchParams([
            ['serviceShopId', serviceShopId],
            ['statusId', statusId],
            ['startDate', moment(startDate).format('YYYY-MM-DD')],
            ['endDate', moment(endDate).format('YYYY-MM-DD')]])


        const response = await baseAxios.get('/Survey/GetSurveyableWorkOrder', { params });
        return response.data;
    });

export const GetSiriusCloseStatus = createAsyncThunk('/GetSiriusCloseStatus', async () => {
    // We are taking only statuses mentioned above, because we expect that after that statuses
    // We should ask survey questions
    const response = await axios.get(`/GetSiriusCloseStatus`);
    return response.data.filter((a) => (a.MobileStatusId === 4) || (a.MobileStatusId === 8) || (a.MobileStatusId === 9) || (a.MobileStatusId === 13) || 
        (a.MobileStatusId === 15) || (a.MobileStatusId === 18)|| (a.MobileStatusId === 19) || (a.MobileStatusId === 44)        
    );
})

export const GetServiceShop = createAsyncThunk('/GetServiceShopRequest', async () => {
    const response = await axios.get(`/GetServiceShopRequest`)
    if (response.data.length > 0) {
        var Data = response.data;
        var allServiceShop = { ServiceShopId: 0, Dsc: "All Service Shop" };
        var subServiceShopControlNew = [...Data, allServiceShop];
        return subServiceShopControlNew.sort((a, b) => (a.ServiceShopId > b.ServiceShopId ? 1 : -1));
    }
    return response.data;
})

export const GetNpsSurveyStatusList = createAsyncThunk('/GetNpsSurveyStatusList', async () => {
    const response = await baseAxios.get(`/Survey/GetNpsSurveyStatusList`);
    return response.data;
})

export const GetWorkOrdersNpsSurveyStatus = createAsyncThunk('/GetWorkOrdersNpsSurveyStatus', async ({workOrderId}) => {
    const params = new URLSearchParams([
        ['workOrderId', workOrderId]])
    const response = await baseAxios.get(`/Survey/GetWorkOrdersNpsSurveyStatus`, { params });
    return response.data;
})

export const SaveNpsSurveyStatusWorkOrder = createAsyncThunk('SaveNpsSurveyStatusWorkOrder', async dto => {
    const response = await baseAxios.post(`/Survey/SaveNpsSurveyStatusWorkOrder`,dto);
    return response.data;
})

const surveySlice = createSlice({
    name: 'survey',
    initialState: {
        InitialSurveyModuleData: [],
        SurveyModuleData: [],
        startDate: moment()
            .startOf('day')
            .add(-7, 'days')
            .add(12, 'hours')
            .format('YYYY-MM-DD'),
        endDate: moment()
            .startOf('day')
            .format('YYYY-MM-DD'),
        searched: '',
        closeStatusList: [],
        selectedStatus: null,
        serviceShopList: [],
        selectedServiceShop: null,
        goDirectlyToTheSurvey: false,
        npsSurveyStatusList: [],
        selectedNpsSurveyStatus: null,
        saveNpsSurveyResponse: null
    },
    reducers: {
        setInitialSurveyModuleData: (state, action) => {
            state.InitialSurveyModuleData = action.payload
        },
        setSurveyModuleData: (state, action) => {
            state.SurveyModuleData = action.payload
        },
        setStartDate: (state, action) => {
            state.startDate = action.payload
        },
        setEndDate: (state, action) => {
            state.endDate = action.payload
        },
        setSearched: (state, action) => {
            state.searched = action.payload
        },
        setSelectedStatus: (state, action) => {
            state.selectedStatus = action.payload
        },
        setSelectedServiceShop: (state, action) => {
            state.selectedServiceShop = action.payload
        },
        setGoDirectlyToTheSurvey: (state, action) => {
            state.goDirectlyToTheSurvey = action.payload
        },
        setSelectedNpsSurveyStatus: (state, action) => {
            state.selectedNpsSurveyStatus = action.payload
        }

    },
    extraReducers: {
        [GetSurveyModuleData.pending]: (state) => {
            state.loading = 'Loading';
        },
        [GetSurveyModuleData.rejected]: (state, action) => {
            state.error = action.payload;
        },
        [GetSurveyModuleData.fulfilled]: (state, action) => {
            state.InitialSurveyModuleData = action.payload;
            state.loading = 'Finished';
        },
        [GetSiriusCloseStatus.pending]: (state) => {
            state.loading = 'Loading';
        },
        [GetSiriusCloseStatus.rejected]: (state, action) => {
            state.error = action.payload;
        },
        [GetSiriusCloseStatus.fulfilled]: (state, action) => {
            state.closeStatusList = action.payload;
            state.loading = 'Finished';
        },
        [GetServiceShop.pending]: (state) => {
            state.loading = 'Loading';
        },
        [GetServiceShop.rejected]: (state, action) => {
            state.error = action.payload;
        },
        [GetServiceShop.fulfilled]: (state, action) => {
            state.serviceShopList = action.payload;
            state.loading = 'Finished';
        },
        [GetNpsSurveyStatusList.pending]: (state) => {
            state.loading = 'Loading';
        },
        [GetNpsSurveyStatusList.rejected]: (state, action) => {
            state.error = action.payload;
        },
        [GetNpsSurveyStatusList.fulfilled]: (state, action) => {
            state.npsSurveyStatusList = action.payload;
            state.loading = 'Finished';
        },
        [GetWorkOrdersNpsSurveyStatus.pending]: (state) => {
            state.loading = 'Loading';
        },
        [GetWorkOrdersNpsSurveyStatus.rejected]: (state, action) => {
            state.error = action.payload;
        },
        [GetWorkOrdersNpsSurveyStatus.fulfilled]: (state, action) => {
            state.selectedNpsSurveyStatus = action.payload;
            state.loading = 'Finished';
        },
        [SaveNpsSurveyStatusWorkOrder.pending]: (state) => {
            state.loading = 'Loading';
        },
        [SaveNpsSurveyStatusWorkOrder.rejected]: (state, action) => {
            state.error = action.payload;
        },
        [SaveNpsSurveyStatusWorkOrder.fulfilled]: (state, action) => {
            state.saveNpsSurveyResponse = action.payload;
            state.loading = 'Finished';
        },
    }
});

export const surveyActions = surveySlice.actions;
export const surveyThunks = {
    GetSurveyModuleData,
    GetSiriusCloseStatus,
    GetServiceShop,
    GetNpsSurveyStatusList,
    GetWorkOrdersNpsSurveyStatus,
    SaveNpsSurveyStatusWorkOrder
}

export default surveySlice.reducer;
